import enquire from 'enquire-js';
import { toggleClass, toggleAttribute } from '../helpers';

const primaryNav = document.querySelector('.primary-navigation');
let ourProductsToggle = primaryNav.querySelector('.primary-navigation > li > a');
let subMenuParents = primaryNav.querySelectorAll('.level-one > .menu-item-has-children > a');
let subMenuChildren = primaryNav.querySelectorAll('.level-two > .menu-item-has-children > a');

let menuOpen = false;

/**
 * Desktop | Handle the Our Products item toggle
 */
function toggleMenuDesktop(e) {
	e.preventDefault();
	const firstSubMenu = primaryNav.querySelector('.menu-item > .sub-menu');

	toggleClass(document.body, 'primary-menu-open');
	toggleAttribute(firstSubMenu, 'aria-hidden');

	// remove all -open classes
	const currentlyOpen = primaryNav.querySelectorAll('.-open');
	currentlyOpen.forEach(item => {
		let openChildren = item.querySelector('[aria-expanded="true"]');
		toggleClass(item, '-open');

		if (openChildren) {
			openChildren.setAttribute('aria-expanded', false);
		}
	});

	menuOpen = !menuOpen;

	this.setAttribute('aria-expanded', menuOpen);
}

/**
 * Handle the first left column sub menu toggling
 */
function toggleSubMenus(e) {

	e.preventDefault();

	const closestMenuItem = e.target.closest('.menu-item');
	const currentlyOpen = primaryNav.querySelectorAll('.-open');

	currentlyOpen.forEach(item => {
		toggleClass(item, '-open');
	});

	if (primaryNav.querySelector('.level-two.-open')) {

		if (closestMenuItem.classList.contains('-open')) {

			return;

		} else {

			toggleAttribute(primaryNav.querySelector('.level-two.-open'), 'aria-hidden');

			primaryNav.querySelector('.level-one .level-two.-open').classList.remove('-open');

			primaryNav.querySelector('.level-one .menu-item-has-children.-open').classList.remove('-open');
		}
	}

	// get the closest .sub-menu to e.target and set it's class and attributes
	const closestSubMenu = e.target.closest('.menu-item').querySelector('.level-two');

	toggleClass(closestSubMenu, '-open');
	toggleClass(closestMenuItem, '-open');
	toggleAttribute(closestSubMenu, 'aria-hidden');

	// Reset aria-expanded on any previously clicked submenu links.
	const otherOpenSubmenu = this.closest('.sub-menu').querySelectorAll('[aria-expanded="true"]');
	if (0 < otherOpenSubmenu.length) {
		otherOpenSubmenu.forEach(item => {
			item.setAttribute('aria-expanded', false);
		});
	}

	this.setAttribute('aria-expanded', true);
}

/**
 * Handle the second left column sub menu toggling
 */
function toggleSubMenusChilds(e) {

	e.preventDefault();

	const closestMenuItem = e.target.closest('.menu-item');

	if (primaryNav.querySelector('.level-three.-open')) {

		if (closestMenuItem.classList.contains('-open')) {

			return;

		} else {

			toggleAttribute(primaryNav.querySelector('.level-three.-open'), 'aria-hidden');

			primaryNav.querySelector('.level-two .level-three.-open').classList.remove('-open');

			primaryNav.querySelector('.level-two .menu-item-has-children.-open').classList.remove('-open');
		}

	}

	// get the closest .sub-menu to e.target and set it's class and attributes
	const closestSubMenu = e.target.closest('.menu-item').querySelector('.level-three');

	toggleClass(closestSubMenu, '-open');
	toggleClass(closestMenuItem, '-open');
	toggleAttribute(closestSubMenu, 'aria-hidden');

	// Reset aria-expanded on any previously clicked submenu links.
	const otherOpenSubmenu = this.closest('.sub-menu').querySelectorAll('[aria-expanded="true"]');
	if (0 < otherOpenSubmenu.length) {
		otherOpenSubmenu.forEach(item => {
			item.setAttribute('aria-expanded', false);
		});
	}

	this.setAttribute('aria-expanded', true);
}

/**
 * Setup pre-interaction state with aria roles on parents/children
 * if <li> has children, add aria-haspopup and aria hidden
 */
function setInitialMenuState() {
	const parents = primaryNav.querySelectorAll('.menu-item-has-children > a');
	const subMenus = primaryNav.querySelectorAll('.menu-item-has-children .sub-menu');

	parents.forEach(parent => {
		const button = document.createElement('button');

		button.innerHTML = parent.innerHTML;
		button.setAttribute('class', 'submenu-toggle');
		button.setAttribute('aria-haspopup', 'true');
		button.setAttribute('aria-expanded', 'false');

		parent.parentNode.replaceChild(button, parent);
	});

	subMenus.forEach(subMenu => {
		subMenu.setAttribute('aria-hidden', 'true');
	});

	let allPrimaryNavItems = primaryNav.querySelectorAll('.primary-navigation > li > a, .primary-navigation > li > button');
	
	allPrimaryNavItems.forEach(navItem => {
		navItem.addEventListener('focus', closeMenu);
	});

	ourProductsToggle = primaryNav.querySelector('.primary-navigation > li > button');
	subMenuParents = primaryNav.querySelectorAll(
		'.primary-navigation > li > .sub-menu > .menu-item-has-children > button'
	);
	subMenuChildren = primaryNav.querySelectorAll('.level-two > .menu-item-has-children > button');

	/**
	 * Listen for clicks on sub menu parent items
	 */
	subMenuParents.forEach(item => {
		item.addEventListener('click', toggleSubMenus);
	});

	subMenuChildren.forEach(item => {
		item.addEventListener('click', toggleSubMenusChilds);
	});



	/**
	 * Listen for clicks on the Our Products item
	 * Fire a separate function for desktop vs mobile
	 */
	enquire.register('screen and ( min-width: 767px )', {
		match: () => {
			ourProductsToggle.addEventListener('click', toggleMenuDesktop);
		}
	});
}

// Close the dropdown and reset classes and attributes
function closeMenu() {

	if ( ! menuOpen ) {
		return;
	}

	toggleClass(document.body, 'primary-menu-open');
	toggleAttribute(primaryNav.querySelector('.menu-item > .sub-menu'), 'aria-hidden');

	menuOpen = !menuOpen;
	ourProductsToggle.setAttribute('aria-expanded', menuOpen);
	subMenuParents.forEach(item => {
		item.setAttribute('aria-expanded', false);
	});
}

// Handle an ESC close via the keyboard
function escCloseForm(e) {
	if (menuOpen) {
		if (27 === e.keyCode) {
			closeMenu();
		}
	}
}

/**
 * Kick things off
 */
setInitialMenuState();

window.addEventListener('keydown', escCloseForm);

// If the menu is open and we scroll, close it
window.addEventListener('scroll', function () {
	if (menuOpen) {
		if (window.scrollY > 25) {
			closeMenu();
		}
	}
});

/**
* Fix button focus outlines.
*/
window.wdsButtonFocusFix = {};
(function (window, app) {

	// Private variable.
	var mouseActive = false;

	// Constructor.
	app.init = function () {
		app.cache();

		if (app.meetsRequirements()) {
			app.bindEvents();
		}
	};

	// Cache all the things.
	app.cache = function () {
		app.$c = {
			buttons: document.querySelectorAll('.primary-navigation button, .hamburger-toggle'),
		};
	};

	// Combine all events.
	app.bindEvents = function () {
		for (const button of app.$c.buttons) {
			button.addEventListener('mousedown', app.handleButtonMousedown);
			button.addEventListener('focus', app.handleButtonFocus);
			button.addEventListener('blur', app.handleButtonBlur);
		}
	};

	// Do we meet the requirements?
	app.meetsRequirements = function () {
		return app.$c.buttons.length;
	};

	// Handle Button Mousedown event.
	app.handleButtonMousedown = function () {
		mouseActive = true;

		window.setTimeout(function () {
			mouseActive = false;
		}, 100);
	};

	// Handle Button Focus event.
	app.handleButtonFocus = function () {
		if (!mouseActive) {
			this.classList.add('md-focused');
		}
	};

	// Handle Button Blur event.
	app.handleButtonBlur = function () {
		this.classList.remove('md-focused');
	};

	// Engage!
	app.init();

}(window, window.wdsButtonFocusFix));
